import * as yup from 'yup';
import {
  hasWohneigentumValidator,
  versicherungsnehmerSchema as versicherungsnehmerSchemaBase,
} from '@/features/Sparten/shared/schema/kfz/versicherungsnehmerSchema/versicherungsnehmerSchema';

const wohneigentumSchema = yup.object({
  gesellschaftID: yup
    .number()
    .default(0)
    .test(
      'hasWohneigentum',
      'Bitte füllen Sie das Pflichtfeld aus.',
      hasWohneigentumValidator,
    ),
  isVermietet: yup.boolean().default(false),
  typ: yup.string().default(''),
});

const jahresticketsSchema = yup.object({
  bahnComfort: yup.boolean().default(false),
  bahnNormal: yup.boolean().default(false),
  sonstige: yup.boolean().default(false),
});

export const versicherungsnehmerSchema = versicherungsnehmerSchemaBase.concat(
  yup.object({
    hasJahreskarteOeffentlicherPersonenverkehr: yup.boolean().default(false),
    jahreskarteOeffentlicherPersonenverkehr: jahresticketsSchema,
    hasAnBegleitetenFahrenTeilgenommen: yup.boolean().default(false),
    hasWohneigentum: yup.boolean().default(false),
    wohneigentum: wohneigentumSchema,
    hasAnSicherheitstrainingTeilgenommen: yup.boolean().default(false),
    hasPunkteInFlensburg: yup.boolean().default(false),
  }),
);
